module.exports = __webpack_public_path__ + "static/media/maystro-blue.14372db5.svg";